<template>
    <div class="bg-grey-4 q-pa-sm">
        <!-- KPI cards -->
        <div class="row q-col-gutter-sm q-mb-sm">
            <kpi-card
                :title="$t('Quality')"
                :value="report.totals.quality.quality"
                :comparisonValue="
                    comparisonReport
                        ? comparisonReport.totals.quality.quality
                        : null
                "
                class="col-md-3 col-sm-12"
            />
            <kpi-card
                :title="$t('Performance')"
                :value="report.totals.performance.performance"
                :comparisonValue="
                    comparisonReport
                        ? comparisonReport.totals.performance.performance
                        : null
                "
                class="col-md-3 col-sm-12"
            />
            <kpi-card
                :title="$t('Availability')"
                :value="report.totals.availability.availability"
                :comparisonValue="
                    comparisonReport
                        ? comparisonReport.totals.availability.availability
                        : null
                "
                class="col-md-3 col-sm-12"
            />
            <kpi-card
                :title="$t('OEE')"
                :value="report.totals.oee"
                :comparisonValue="
                    comparisonReport ? comparisonReport.totals.oee : null
                "
                class="col-md-3 col-sm-12"
            />
        </div>

        <!-- KPI charts -->
        <div class="row q-col-gutter-sm">
            <div
                :class="
                    comparisonReport
                        ? 'col-lg-6 col-sm-12 col-xs-12'
                        : 'col-lg-4 col-sm-12 col-xs-12'
                "
            >
                <kpi-quality-chart
                    :report="report"
                    :comparisonReport="comparisonReport"
                    class="kpi-chart"
                ></kpi-quality-chart>
            </div>
            <div
                :class="
                    comparisonReport
                        ? 'col-lg-12 col-sm-12 col-xs-12 order-last'
                        : 'col-lg-4 col-sm-12 col-xs-12'
                "
            >
                <kpi-performance-chart
                    :report="report"
                    :comparisonReport="comparisonReport"
                    class="kpi-chart"
                ></kpi-performance-chart>
            </div>
            <div
                :class="
                    comparisonReport
                        ? 'col-lg-6 col-sm-12 col-xs-12'
                        : 'col-lg-4 col-sm-12 col-xs-12'
                "
            >
                <kpi-availability-chart
                    :report="report"
                    :comparisonReport="comparisonReport"
                    class="kpi-chart"
                ></kpi-availability-chart>
            </div>
        </div>

        <!-- Performance rates chart -->
        <div class="q-pt-sm">
            <performance-rates-chart
                :report="report"
                :comparisonReport="comparisonReport"
                class="col performance-rates-chart"
            ></performance-rates-chart>
        </div>

        <!-- Availability chart -->
        <div class="q-pt-sm">
            <availability-chart
                :report="report"
                :comparisonReport="comparisonReport"
                class="col availability-chart"
            ></availability-chart>
        </div>

        <!-- Availability unplanned downtime chart -->
        <div class="q-pt-sm">
            <availability-downtime-chart
                :report="report"
                :comparisonReport="comparisonReport"
                class="col availability-downtime-chart"
            ></availability-downtime-chart>
        </div>
    </div>
</template>

<script>
import KPICard from './KPICard.vue';
import KPIQualityChart from './KPIQualityChart.vue';
import KPIAvailabilityChart from './KPIAvailabilityChart.vue';
import KPIPerformanceChart from './KPIPerformanceChart.vue';
import PerformanceRatesChart from './PerformanceRatesChart.vue';
import AvailabilityChart from './AvailabilityChart.vue';
import AvailabilityDowntimeChart from './AvailabilityDowntimeChart.vue';

export default {
    name: 'PerformanceDashboard',
    components: {
        'kpi-card': KPICard,
        'kpi-availability-chart': KPIAvailabilityChart,
        'kpi-quality-chart': KPIQualityChart,
        'kpi-performance-chart': KPIPerformanceChart,
        PerformanceRatesChart,
        AvailabilityChart,
        AvailabilityDowntimeChart
    },
    props: {
        report: {
            type: Object,
            required: false
        },
        comparisonReport: {
            type: Object,
            required: false
        }
    }
};
</script>

<style lang="scss" scoped>
// remove shadow from q-cards
:deep(.q-card) {
    box-shadow: none;
}

.kpi-chart {
    height: 350px;
}
</style>
